const {jQuery: $} = window;

import Utils from "./utils.class";

export default class AutoClip {
    #$bg;
    #$el;

    constructor(bgSelector, areaSelector, opacity) {
        const $bgContainer = $(bgSelector);
        this.#$el = $(areaSelector);

        if($bgContainer.length === 0 || this.#$el.length === 0) {
            Utils.log("Unable to create AutoClip from:", bgSelector, areaSelector);
            return;
        }

        if($bgContainer[0].style.position === "static" || $bgContainer[0].style.position === "") {
            $bgContainer[0].style.position = "relative";
        }

        const bgEL = $("<div class='js--auto-clip-bg'></div>").css({
            "position": "absolute",
            "top": "0",
            "left": "0",
            "right": "0",
            "bottom": "0",
            "z-index": "-1",
            "opacity": opacity || ".6",
            "background-color": "inherit"
        });

        $bgContainer.append(bgEL);

        this.#$bg = $(bgEL);

        window.addEventListener('resize', () => this.#resize(), {passive: true});
        window.addEventListener('load', () => this.#resize());
        document.addEventListener('ready', () => this.#resize());

        this.#resize();
    }

    #resize() {
        const clip = this.#$el[0].getBoundingClientRect();
        const parent = this.#$bg[0].getBoundingClientRect();

        const rect = {
            top: clip.top - parent.top,
            bottom: (clip.top - parent.top) + clip.height,
            left: clip.left - parent.left,
            right: (clip.left - parent.left) + clip.width
        };

        this.#$bg.css('clip-path', `polygon(0% 0%, 0% 100%, ${rect.left}px 100%, ${rect.left}px ${rect.top}px, ${rect.right}px ${rect.top}px, ${rect.right}px ${rect.bottom}px, ${rect.left}px ${rect.bottom}px, ${rect.left}px 100%, 100% 100%, 100% 0%)`);
    }
}